import angular from 'angular';

import { PatientConnectionService } from './patientConnection.service';
import { PatientConnectionComponent } from './patientConnection.component';
import { SignupComponent } from './signup/patientConnection.signup.component';
import { VerifyFormComponent } from './verifyForm/patientConnection.verifyForm.component';
import { MergeComponent } from './merge/patientConnection.merge.component';
import { CompletedComponent } from './completed/patientConnection.completed.component';

export const PatientConnectionModule = angular
    .module('mmsApp.pages.patientConnection', [
    ])
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('pages.patientConnection', {
                url: '/patientConnection?token',
                data: {
                    isAuthRequired: false,
                },
            })
            .state('pages.patientConnection.signup', {
                component: SignupComponent.name,
                params: {
                    emailAddress: '',
                    userFullName: '',
                },
                resolve: {
                    emailAddress: ($transition$) => {
                        return $transition$.params().emailAddress;
                    },
                    emailToken: ($transition$) => {
                        return $transition$.params().token;
                    },
                    userFullName: ($transition$) => {
                        return $transition$.params().userFullName;
                    },
                    onSignup: ($transition$, $state) => {
                        return () => {
                            $state.go('pages.patientConnection.main');
                        };
                    }
                }
            })
            .state('pages.patientConnection.main', {
                component: PatientConnectionComponent.name,
                resolve: {
                    emailToken: ($transition$) => {
                        return $transition$.params().token;
                    }
                }
            })
    })
    .service('PatientConnectionService', PatientConnectionService)
    .component(PatientConnectionComponent.name, PatientConnectionComponent.component)
    .component(SignupComponent.name, SignupComponent.component)
    .component(VerifyFormComponent.name, VerifyFormComponent.component)
    .component(MergeComponent.name, MergeComponent.component)
    .component(CompletedComponent.name, CompletedComponent.component)
    .run(($transitions, PatientConnectionService) => {
        'ngInject';
        $transitions.onBefore({ to: 'pages.patientConnection' }, redirectNewUser);
        function redirectNewUser(transition) {
            let AppUserService = transition.injector().get('AppUserService');
            let PatientConnectionService = transition.injector().get('PatientConnectionService');
            let $state = transition.router.stateService;

            if (!AppUserService.isAuthenticated()) {
                let { token } = transition.params();
                return PatientConnectionService.getPatientConnectionUser(token)
                    .then((result) => {
                        const { email, firstName, lastName } = result
                        let params = Object.assign({}, transition.params(), { emailAddress: email, userFullName: `${firstName} ${lastName}` });
                        let signupState = $state.target('pages.patientConnection.signup', params);
                        let loginState = $state.target('pages.login', params, { location: false });
                        return result.isNewUser ? signupState : loginState;
                    })
                    .catch(err => {
                        return $state.target('pages.404', undefined, { location: false, reload: true });
                    });
            }
            return $state.target('pages.patientConnection.main', transition.params());
        }
    })
    .name
    ;



// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/patientConnection.module.js